// extracted by mini-css-extract-plugin
module.exports = {"top-section":"Stakepage_top-section__1YMp5","dark-background":"Stakepage_dark-background__cesRn"};